import store from '@/store/index.js';
let host = `//${location.host}`,
    websiteLogin = '//www.batmobi.net/adsLogin',
    testLogin = '//test.group.batmobi.net/dist/view/login.html',
    classArr = 'Boolean Number String Function Array Date RegExp Object Error'.split(' '),
    classType = {}, //收录所有对象类型
    apiHost,
    common,
    getLocationArg,
    backendApi,
    dspAdmin;
classArr.forEach(name => (classType[`[object ${name}]`] = name.toLowerCase()));

switch (location.host) {
case 'localhost:8080':
    apiHost = '//testdsp.batmobi.net';
    dspAdmin = '//test.admin.batmobi.net/index.html#/';
    websiteLogin = testLogin;
    host = '//test.group.batmobi.net';
case 'test.group.batmobi.net':
    apiHost = '//testdsp.batmobi.net';
    dspAdmin = '//test.admin.batmobi.net/index.html#/';
    websiteLogin = testLogin;
    break;
case 'd.batmobi.net':
    apiHost = '//portalapi.adfundsp.com';
    dspAdmin = '//dspadmin.batmobi.net/index.html#/';
    break;
case 'test-dspadmin.adfundsp.com/':
    apiHost = '//test-portalapi.adfundsp.com'
    dspAdmin = '//test-dspadmin.batmobi.net/index.html#/';
default:
    apiHost = '//portalapi.adfundsp.com';
    dspAdmin = '//dspadmin.batmobi.net/index.html#/';
    break;
}

export default (common = {
    dspAdmin,
    dashboardSummaryPort: apiHost + '/manager/dashboardSummary',
    batchUpdateCampaignStatusPort: apiHost + '/manager/batchUpdateCampaignStatus',
    dashboardCampaignInfoPort: apiHost + '/manager/dashboardCampaignInfo',
    campaignInfoPort: apiHost + '/manager/campaignList',
    campaignSummaryPort: apiHost + '/manager/campaignSummary',
    cpiCampaignInfoPort: apiHost + '/manager/cpiCampaignList',
    cpiCampaignSummaryPort: apiHost + '/manager/cpiCampaignSummary',
    //获取媒体app列表
    getAppListPort: apiHost + '/manager/listApp',
    //CPI出价更新
    updateCPIBidPricePort: apiHost + '/manager/updateCPIBidPrice',
    //CPI日激活批量更新
    updateCPIDailyActivityPort: apiHost + '/manager/updateCPIDailyActivity',
    //创意开
    openOfferPort: apiHost + '/manager/openOffer',
    //创意关
    closeOfferPort: apiHost + '/manager/closeOffer',
    //创意删除
    delOfferPort: apiHost + '/manager/delOffer',
    //推广开
    openCampaignPort: apiHost + '/manager/openCampaign',
    //推广关
    closeCampaignPort: apiHost + '/manager/closeCampaign',
    //推广归档
    archiveCampaignPort: apiHost + '/manager/archiveCampaign',
    //还原归档
    unArchiveCampaignPort: apiHost + '/manager/unArchiveCampaign',
    //国家列表
    getCountryListPort: apiHost + '/manager/getCountryList',
    //操作系统和版本
    getOsListPort: apiHost + '/manager/getOsList',
    //渠道信息
    getSourceListPort: apiHost + '/manager/getSourceList',
    //设备和类型
    getDeviceListPort: apiHost + '/manager/getDeviceList',
    //新建推广
    addCampaignPort: apiHost + '/manager/addCampaign',
    //新建CPI推广
    addCPICampaignPort: apiHost + '/manager/addCPICampaign',
    //更新推广
    updateCampaignPort: apiHost + '/manager/updateCampaign',
    //更新推广
    updateCPICampaignPort: apiHost + '/manager/updateCPICampaign',
    //获取推广详情
    getCampaignPort: apiHost + '/manager/getCampaign',
    //复制推广
    copyCampaignPort: apiHost + '/manager/copyCampaign',
    //批量更新
    batchUpdateCampaignPort: apiHost + '/manager/batchUpdateCampaign',
    //代码监测统计
    transferPort: apiHost + '/thirdpage/transfer',
    //上传图片
    upLoadImgPort: apiHost + '/manager/uploadImg',
    //上传视频
    upLoadVideoPort: apiHost + '/manager/uploadVedio',
    //代码监测校验
    verifyStatsCodePort: apiHost + '/code/verifyStatsCode',
    //获取重定向人群
    listTargetort: apiHost + '/manager/listTarget',
    //推广类型获取
    campaignTypePort: apiHost + '/manager/listCampaignType',

    //推广下拉
    campaignSearchPort: apiHost + '/report/campaign/search',
    //指标下拉
    quotaListPort: apiHost + '/report/dimension/list',
    //报表页列表
    reportDataPort: apiHost + '/report/data',
    //报表页汇总数据
    reportSummary: apiHost + '/report/summary',
    reportDownload: apiHost + '/report/download',
    //获取用户信息
    getUserDataPort: apiHost + '/manager/getUserData',
    //登出
    logOutPort: apiHost + '/manager/logOut',
    //sdk路径
    sdkURL: host + '/dist/js/batmobi_jssdk.min.js',
    async get(url, params, vue, success, fail = () => {}) {
        let str = '';
        for (let item in params) {
            str += `${item}=${params[item]}&`;
        }
        try {
            let res = await vue.$http.get(`${url}?${str}rd=${new Date().getTime()}`);
            this.toWebSite(res.data.status);
            if (res.data.status == 200 || res.data.status == 304) {
                success(res.data.data, res.data);
            } else if (res.data.status != 403) {
                this.popup(res.data.message);
            }
        } catch (err) {
            fail(err);
        } finally {
            this.loadingCloseDelay(vue);
            vue.loadingHasClose = false;
        }
    },
    //正常post
    post(url, params, vue, success, fail) {
        let obj = this.createXmlHttp();
        obj.open('POST', url, true);
        obj.setRequestHeader('Content-type', 'application/x-www-form-urlencoded'); // 添加http头，发送信息至服务器时内容编码类型
        obj.withCredentials = true; //支持跨域发送cookies
        obj.onreadystatechange = () => {
            if (obj.readyState == 4 && (obj.status == 200 || obj.status == 304)) {
                // 304未修改
                this.toWebSite(obj.responseText.status);
                success.call(this, JSON.parse(obj.responseText));
                this.loadingClose(vue);
                vue.loadingHasClose = false;
            } else if (obj.readyState == 4) {
                fail.call(this, JSON.parse(obj.responseText));
                this.loadingClose(vue);
                vue.loadingHasClose = false;
            }
        };
        obj.send(JSON.stringify(params));
    },
    //post表单
    postForm(element, url, succeed, fail, progress, cancel) {
        let form = new FormData(element),
            req = this.createXmlHttp();
        req.open('post', url, true);
        req.withCredentials = true; //支持跨域发送cookies
        //req.open("post", "http://localhost:8080/manager/uploadVideo", false);

        //返回进度
        req.upload.addEventListener(
            'process',
            evt => {
                if (evt.lengthComputable && progress) progress();
                //let percentComplete=Math.round(evt.loaded*100/evt.total);//可以在这里接收进度条数据
            },
            false
        );

        //上传成功返回来的数据
        req.addEventListener(
            'load',
            evt => {
                let responseText = JSON.parse(evt.target.responseText);
                this.toWebSite(responseText.status);
                if (succeed) succeed(evt);
            },
            false
        );

        //上传失败//返回异常
        req.addEventListener(
            'error',
            evt => {
                if (fail) fail(evt);
            },
            false
        );

        //上传已由用户或浏览器取消删除连接//返回连接异常
        req.addEventListener(
            'abort',
            evt => {
                if (cancel) cancel(evt);
            },
            false
        );
        req.send(form);
    },
    createXmlHttp() {
        let xmlHttp;
        try {
            // Firefox, Opera 8.0+, Safari
            xmlHttp = new XMLHttpRequest();
        } catch (e) {
            try {
                // Internet Explorer
                xmlHttp = new ActiveXObject('Msxml2.XMLHTTP');
            } catch (e) {
                try {
                    xmlHttp = new ActiveXObject('Microsoft.XMLHTTP');
                } catch (e) {}
            }
        }
        return xmlHttp;
    },
    //失败则去官网
    toWebSite(status) {
        if (status == 401) this.toAdsLogin();
    },
    toAdsLogin() {
        window.location.href = websiteLogin;
    },
    //存储cookie
    setCookie(name, value, time) {
        //默认保存一个月
        let hour = time ? time : 30 * 24,
            exp = new Date();
        exp.setTime(exp.getTime() + hour * 60 * 60 * 1000);
        //时间为0是不设置expires的值
        let expires = time === 0 ? '' : `;expires=${exp.toGMTString()}`;
        document.cookie = `${name}=${escape(value)}${expires}`;
    },
    //获取cookie
    getCookie(name) {
        let reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
        let arr = [];
        return (arr = document.cookie.match(reg) ? unescape(arr[2]) : null);
    },
    //删除cookie
    delCookie(name) {
        let exp = new Date(),
            cval = this.getCookie(name);
        exp.setTime(exp.getTime() - 1);
        if (cval != null) document.cookie = `${name}=${cval};expires=${exp.toGMTString()}`;
    },
    //获取url上参数
    getQueryObject(url = window.location.href) {
        let search = url.substring(url.lastIndexOf('?') + 1),
            obj = {},
            reg = /([^&=]+)=([^&=]*)/g;
        search.replace(reg, (rs, $1, $2) => {
            let name = decodeURIComponent($1);
            let val = decodeURIComponent($2);
            val = String(val);
            obj[name] = val;
            return rs;
        });
        return obj;
    },
    popup(text, time = 3000) {
        store.dispatch('toast', { message: text, duration: time });
    },
    //获取元素相对body的左偏移值和上偏移值
    offset(curEle) {
        let totalLeft = null,
            totalTop = null,
            par = curEle.offsetParent;
        // 首先把自己本身的进行累加：
        totalLeft += curEle.offsetLeft;
        totalTop += curEle.offsetTop;

        // 只要没有找到body，我们就把父级参照物的边框和偏移进行累加
        while (par) {
            if (navigator.userAgent.indexOf('MSIE 8.0') === -1) {
                //不是标准ie8浏览器才累加边框
                // 累加父级参照物的边框
                totalLeft += par.clientLeft;
                totalTop += par.clientTop;
            }

            // 累加父级参照物的偏移
            totalLeft += par.offsetLeft;
            totalTop += par.offsetTop;

            par = par.offsetParent;
        }
        return { left: totalLeft, top: totalTop };
    },
    loadingOpen(vue) {
        let loadingSwitch = store.state.loadingSwitch;
        if (loadingSwitch === false) store.commit('setLoadingSwitch', true);
    },
    loadingClose(vue) {
        let loadingSwitch = store.state.loadingSwitch;
        if (loadingSwitch === true) store.commit('setLoadingSwitch', false);
    },
    loadingOpenDelay(vue, time = 500) {
        vue.loadingHasClose = true;
        setTimeout(() => {
            if (vue.loadingHasClose) this.loadingOpen(vue);
        }, time);
    },
    loadingCloseDelay(vue, time = 500) {
        setTimeout(() => this.loadingClose(vue), time);
    },
    //修改页面的标题
    setPageTitle(title) {
        let $body = document.body,
            $iframe = document.createElement('iframe');
        if (title) document.title = title;
        $iframe.style.display = 'none';
        $iframe.src = '//user';
        $iframe.onload = () => setTimeout(() => this.parentNode.removeChild(this), 10);
        document.body.appendChild($iframe);
    },
    //自动触发点击
    triggerClick(element) {
        if (document.all) {
            element.click();
            return;
        }
        // 其它浏览器
        let e = document.createEvent('MouseEvents');
        e.initEvent('click', true, true);
        element.dispatchEvent(e);
    },
    //实现千分位
    comdify(n) {
        if (typeof n === 'undefined') n = 0;
        let re = /\d{1,3}(?=(\d{3})+$)/g,
            n1 = n.toString().replace(/^(\d+)((\.\d+)?)$/, (s, s1, s2) => s1.replace(re, '$&,') + s2);
        return n1;
    },
    //四射五入保留两位小数
    toFixed(number, n) {
        return Math.round(number * Math.pow(10, n)) / Math.pow(10, n).toFixed(n);
    },
    //美元格式化
    dollorStyle(num) {
        if (typeof num == 'undefined' || isNaN(num)) num = 0;
        return `$${this.comdify(this.toFixed(num, 2))}`;
    },
    //毫秒转成小时，分钟，秒
    //时间戳转换
    getUtcTime(timestamp, format = 'dot') {
        let d = new Date(timestamp),
            charDate;
        if (format == 'tomorrow') d.setDate(d.getDate() + 1);
        //根据date对象获取详细时间
        let year = parseInt(d.getUTCFullYear()),
            month = parseInt(d.getUTCMonth() + 1),
            dates = parseInt(d.getUTCDate()),
            hours = parseInt(d.getUTCHours()),
            minutes = parseInt(d.getUTCMinutes()),
            week = parseInt(d.getUTCDay());
        //小于10的数字前面加0
        if (month < 10) month = `0${month}`;
        if (dates < 10) dates = `0${dates}`;
        if (hours < 10) hours = `0${hours}`;
        if (minutes < 10) minutes = `0${minutes}`;
        //输入需要的时间格式

        //以"."为分隔符，默认此项 2016.9.21 12:00
        if (format == 'dot') charDate = `${year}-${month}-${dates}`;
        return charDate;
    },
    today() {
        return this.getUtcTime(new Date().getTime());
    },
    yesterday() {
        return this.getUtcTime(new Date().getTime() - 3600 * 1000 * 24);
    },
    week() {
        return this.getUtcTime(new Date().getTime() - 3600 * 1000 * 24 * 7);
    },
    mouth() {
        return this.getUtcTime(new Date().getTime() - 3600 * 1000 * 24 * 30);
    },
    //明年
    nextYear() {
        return this.getUtcTime(new Date().getTime() + 3600 * 1000 * 24 * 365);
    },
    //下N年
    nextNumYear(n = 1) {
        return this.getUtcTime(new Date().getTime() + 3600 * 1000 * 24 * 365 * n);
    },
    CTR(click, imp) {
        let param = click && imp ? (click / imp) * 100 : 0;
        return `${this.toFixed(param, 2)}%`;
    },
    CPM(spends, imp) {
        return this.dollorStyle(spends && imp ? (spends / imp) * 1000 : 0);
    },
    CPC(spends, click) {
        return this.dollorStyle(spends && click ? spends / click : 0);
    },
    CPS(spends, deal) {
        return this.dollorStyle(spends && deal ? spends / deal : 0);
    },
    type(obj) {
        return obj == null ? String(obj) : classType[Object.prototype.toString.call(obj)] || 'object';
    },
});



// WEBPACK FOOTER //
// ./src/utils/common.js